import { Game } from "../Game";
import { Camera } from "./Camera";
import { TimeManager } from "../Utils/Time/TimeManager";
import { GameWorld } from "./Game World/GameWorld";
import { Timer } from "../Utils/Time/Timer";
import { HUD } from "./HUD/HUD";
import { BonusManager } from "./Bonuses/BonusManager";
import { Player } from "./Player/Player";
import { ParcelManager } from "./Parcel/ParcelManager";
import { LevelManager } from "./Levels";
import * as Gamee from "../Gamee/GameeWrapper";
import { LevelIntro } from "./HUD/LevelIntro";
import { KeepPlaying } from "./HUD/KeepPlaying";
import { SoundManager } from "../Utils/SoundManager";



export const TIME: TimeManager = new TimeManager();
export const TIMER: Timer = TIME.createTimer();



export const enum eState {
    waitForStart,
    play,
    lvlComplete,
    nextLvlIntro,
    keepPlaying,
    gameOver,
    waitForGameeStart
}



export const enum eBatchGroup {
    bakedStatic,
    bakedDynamic,
    walls,
    dynamic,
    fakeShadows,
}



export class Gameplay {
    /**
     * Staticky pristup
     */
    static get instance(): Gameplay { return Gameplay._instance; }
    private static _instance: Gameplay;

    /**
     * (RO) Spravce udalosti
     */
    get events(): pc.EventHandler { return this._events; }
    private _events: pc.EventHandler;

    /**
     * (RO) Aktualni stav
     */
    get state(): eState { return this._state; }
    private _state: eState;

    private _stateTime: number;

    /**
     * (RO) Celkovy pocet balicku, ktere je potreba sebrat pro dokonceni levelu
     */
    get levelPackageCnt(): number { return this._lvlPkgCnt; }
    private _lvlPkgCnt: number;

    private static readonly _LVL_DELIVERY_DEF_CNT = 3;
    private static readonly _LVL_DELIVERY_MAX_CNT = 6;

    /**
     * Zapecene svetlo
     */
    private _bakedLight: pc.Entity;

    /**
     * (RO) Batch skupiny. Indexuje se pres eBatchGroup
     */
    get batchGroups(): number[] { return this._batchGroups; }
    private _batchGroups: number[];

    private _parcelMng: ParcelManager;
    private _levels: LevelManager;
    private _camera: Camera;
    private _hud: HUD;
    private _bonuses: BonusManager;
    private _gameWorld: GameWorld;
    private _player: Player;

    /**
     * Zbyvajici pocet extra zivotu
     */
    private _extraLifeCnt: number;

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor() {
        Gameplay._instance = this;

        let app = Game.APP;

        // Spravce udalosti
        this._events = new pc.EventHandler();

        // Lights
        this._bakedLight = new pc.Entity("bakedLight");
        this._bakedLight.addComponent(pc.eCompomentType.light, {
            type: pc.LIGHTTYPE_DIRECTIONAL,
            intensity: 1,
            isStatic: true,

            bake: true,
            bakeDir: true,
            affectDynamic: false,
            affectLightmapped: true,

            castShadows: true,
            shadowResolution: 2048,
            shadowType: pc.SHADOW_PCF5,
            shadowBias: 0.2,
            shadowUpdateMode: 2,
            normalOffsetBias: 0.1,
        });
        this._bakedLight.setEulerAngles(0, 0, 10);
        this._bakedLight.light.color.set(1, 0.925, 0.925);

        app.root.addChild(this._bakedLight);
        app.scene.lightmapSizeMultiplier = 64;

        let dynamicLight = new pc.Entity("dynamicLight");
        dynamicLight.addComponent(pc.eCompomentType.light, {
            type: pc.LIGHTTYPE_DIRECTIONAL,
            intensity: 1,
            isStatic: true,
            bake: false,
            affectDynamic: true,
            affectLightmapped: false,
            castShadows: false,
        });
        dynamicLight.setEulerAngles(0, 0, 10);
        dynamicLight.light.color.set(1, 0.925, 0.925);
        app.root.addChild(dynamicLight);

        app.scene.ambientLight.set(0.675, 0.675, 0.75);

        // Batch groups
        this._batchGroups = [
            app.batcher.addGroup(eBatchGroup.bakedStatic.toString(), false, 100).id,
            app.batcher.addGroup(eBatchGroup.bakedDynamic.toString(), true, 100).id,
            app.batcher.addGroup(eBatchGroup.walls.toString(), true, 100).id,
            app.batcher.addGroup(eBatchGroup.dynamic.toString(), true, 100).id,
            app.batcher.addGroup(eBatchGroup.fakeShadows.toString(), true, 100).id,
        ];

        // Kamera
        this._camera = new Camera();

        // Levely
        this._levels = new LevelManager();

        // Bonusy
        this._bonuses = new BonusManager();;

        // Balicky
        this._parcelMng = new ParcelManager();

        // Herni svet
        this._gameWorld = new GameWorld();

        // Hrac
        this._player = new Player();
        this._events.on(Player.EVENT_DEATH, this.handlePlDeath, this);
        this._events.on(Player.EVENT_PARCEL_DELIVERED, this.handlePlPkgDeliver, this);

        // HUD
        this._hud = new HUD();

        this._events.on(LevelIntro.EVENT_COMPLETE, this.handleLvlIntroComplete, this);
        this._events.on(KeepPlaying.EVENT_COMPLETE, this.handleKeepPlayingComplete, this);

        // Zachytavat udalosti mysi
        app.mouse.on(pc.EVENT_MOUSEDOWN, (event: pc.MouseEvent) => { this.handlePointerDown(event.event); }, this);
        app.touch.on(pc.EVENT_TOUCHSTART, (event: pc.TouchEvent) => { this.handlePointerDown(event.event); }, this);

        // Zachytavat stisknuti klaves
        app.keyboard.on(pc.EVENT_KEYDOWN, this.handleKeyDown, this);

        this.reset();

        // GAMEE
        this._state = eState.waitForGameeStart;

        Gamee.Wrapper.EVENTS.on(Gamee.eEvent.start, this.handleGameeStart, this);
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    update(deltaS: number): void {
        if (this._state >= eState.keepPlaying)
            return;

        TIME.update(deltaS);

        this._bonuses.update();
        this._gameWorld.update();
        this._player.update();
        this._camera.update();
        this._hud.update();
        this._parcelMng.update();

        if (this._state == eState.lvlComplete) {
            if (this._stateTime + 750 < TIMER.time) {
                // Zavrit obrazovku a zobrazit cislo noveho levelu
                this._state = eState.nextLvlIntro;
                this._hud.lvlIntro.start(this._levels.lvlNum + 1);
            }
        }
    }

    //-------------------------------------------------------------------------
    /**
     * Navyseni skore o danou hodnotu
     * @param value 
     */
    //-------------------------------------------------------------------------
    incScore(value: number): void {
        Gamee.Wrapper.SCORE += value;
    }

    //-------------------------------------------------------------------------
    /**
     * Inicializace levelu 
     */
    //-------------------------------------------------------------------------
    private initLevel(): void {
        let settings = this._levels.lvlSettings;

        // Odstranit vydejny a dodavky
        this._parcelMng.release();

        // Vytvorit herni svet
        this._gameWorld.createLevel(settings.gameWorld);

        // Hrac
        this._player.init(settings.player);

        // Rebatch
        Game.APP.batcher.generate();

        // Zapect svetlo
        this._bakedLight.light.shadowDistance = settings.shadowDistance;
        Game.APP.lightmapper.bake();

        // Pocet balicku, ktere hrac musi dorucit pro dokonceni levelu
        if ((this._lvlPkgCnt = Gameplay._LVL_DELIVERY_DEF_CNT + (this._levels.lvlNum - 1)) > Gameplay._LVL_DELIVERY_MAX_CNT)
            this._lvlPkgCnt = Gameplay._LVL_DELIVERY_MAX_CNT;

        this._lvlPkgCnt *= settings.player.charCnt;

        // Reset
        this._state = eState.waitForStart;

        this._hud.reset(true);
        this._bonuses.reset();
        this._gameWorld.reset();
        this._player.reset(false);
        this._parcelMng.reset();
        this._camera.reset();
    }

    //-------------------------------------------------------------------------
    /**
     * Reset hry
     */
    //-------------------------------------------------------------------------
    private reset(): void {
        TIMER.start();

        this._extraLifeCnt = 1;
        this._state = eState.waitForStart;

        this._hud.reset(false);
        this._levels.reset();
        this.initLevel();
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    private gameOver(): void {
        SoundManager.stop();
        this._state = eState.gameOver;
        Gamee.Wrapper.gameOver();
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    private handleKeyDown(event: pc.KeyboardEvent): void {
        /*if (Game.PAUSED)
            return;

        if (event.key == pc.KEY_SPACE) {
            this.handlePlDeath();
        }
        /*else if (event.key == pc.KEY_1) {
            this._bonuses.activateBonus(BONUSES[eBonusUID.shield]);
        }
        else if (event.key == pc.KEY_2) {
            this._bonuses.activateBonus(BONUSES[eBonusUID.scoreMultiplier]);
        }*/
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    private handlePointerDown(event: Event): void {
        if (Game.PAUSED)
            return;

        if (this._state == eState.waitForStart) {
            this._state = eState.play;
            BonusManager.ACT_BONUS_TIMER.resume();
            this._player.startWalking();
            event.preventDefault();
        }
        else if (this._state == eState.play) {
            // Zmena smeru pohybu hrace
            this._player.flipWalkDir();
            event.preventDefault();
        }
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    private handleLvlIntroComplete(): void {
        // Prechod do dalsiho levelu
        this._levels.goToNextLevel();
        this.initLevel();
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    private handleKeepPlayingComplete(res: boolean): void {
        if (res) {
            // Ozivit hrace
            this._player.reset(true);
            this._parcelMng.reset();
            this._camera.reset();

            this._extraLifeCnt--;

            SoundManager.resume();

            this._state = eState.waitForStart;
        }
        else {
            this.gameOver();
        }
    }

    //-------------------------------------------------------------------------
    /**
     * Zpracovat doruceni balicku hracem
     * @param pkgCnt Pocet balicku, ktere hrac dorucil
     * @param totPkgCnt Celkovy pocet dorucenych balicku
     */
    //-------------------------------------------------------------------------
    private handlePlPkgDeliver(pkgCnt: number, totPkgCnt: number): void {
        if (totPkgCnt >= this._lvlPkgCnt) {
            // Prechod do dalsiho levelu
            this._state = eState.lvlComplete;
            this._stateTime = TIMER.time;
        }
    }

    //-------------------------------------------------------------------------
    /**
     * Zpracovat smrt hrace
     */
    //-------------------------------------------------------------------------
    private handlePlDeath(): void {
        if (Gamee.Wrapper.adReady && this._extraLifeCnt > 0 && this._levels.lvlNum > 1) {
            // Pozastavit casovac pro aktivni bonusy
            BonusManager.ACT_BONUS_TIMER.pause();

            // Pozastavit hudbu a zvuky
            SoundManager.pause();

            // Zobrazit dotaz
            this._state = eState.keepPlaying;
            this._hud.keepPlaying.show();
        }
        else {
            this.gameOver();
        }
    }

    //-------------------------------------------------------------------------
    /**
     * Zpracovat Gamee.start udalost
     */
    //-------------------------------------------------------------------------
    private handleGameeStart(): void {
        Gamee.Wrapper.loadAd();

        if (this._state == eState.waitForGameeStart) {
            this._state = eState.waitForStart;
        }
        else {
            this.reset();
        }
    }
}